import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AuthorizationService } from './api/authorization.service';
import { AuthorizationPasswordService } from './api/authorizationPassword.service';
import { ImagesService } from './api/images.service';
import { PartService } from './api/part.service';
import { RoleService } from './api/role.service';
import { TransactionDataService } from './api/transactionData.service';
import { TransactionListService } from './api/transactionList.service';
import { UserService } from './api/user.service';
import { WarehouseService } from './api/warehouse.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
